import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { api } from '@app/utils/api';
import { BI_BASE_URL } from '@app/contstants/endpoints';
import { errorHandler } from '@app/utils/errorHandler';
import { YearlyBonusResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year?: number;
};

const getManagerYearlyBonus = async (params: Params): Promise<YearlyBonusResponse> => {
  const { data } = await api.get<YearlyBonusResponse>(
    `${BI_BASE_URL}/managers/bonus/yearly/progress`,
    { params }
  );

  return data;
};

export const useGetManagerYearlyBonus = ({
  year,
}: Params): UseQueryResult<YearlyBonusResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.YEARLY_BONUS_PROGRESS, year],
    queryFn: () => getManagerYearlyBonus({ year }),
    ...errorHandler,
  });
};
